import {Box, Stack} from '@mui/material';
import styled from 'styled-components';

const StyledBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	border-radius: 8px;
`;

const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.colors.light.info['190Percent']};
	padding: 12px 16px;
	border-radius: 0 0 8px 8px;
`;

export {StyledBox, StyledStack};
